import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["className"];
import clsx from 'clsx';
import * as React from 'react';
import { Base } from '../../Base';
var styles = {
  "root": "ListHelp-root_2RJS3"
};
function ListHelp(_ref) {
  var className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "p",
    flexBasis100: true,
    marginY: "none",
    size: "base",
    weight: "regular",
    className: clsx(styles.root, className)
  }, extraProps));
}
ListHelp.displayName = 'TypoListHelp';
export { ListHelp };